import { render, staticRenderFns } from "./routerAdd.vue?vue&type=template&id=6e94c2b0&"
import script from "./routerAdd.vue?vue&type=script&lang=js&"
export * from "./routerAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QList,QExpansionItem,QIcon,QAvatar,QBtnGroup,QDialog,QCheckbox,QCardActions,ClosePopup} from 'quasar'
component.options.components = Object.assign({QCard,QCardSection,QInput,QBtn,QTooltip,QSeparator,QList,QExpansionItem,QIcon,QAvatar,QBtnGroup,QDialog,QCheckbox,QCardActions}, component.options.components || {})
component.options.directives = Object.assign({ClosePopup}, component.options.directives || {})
